<template>
  <div
    class="bg-primary-light q-pa-md rounded-borders sai-print-avoid-break-inside"
  >
    <slot name="header">
      <p class="text-center text-weight-medium text-primary">
        Your Total Savings
      </p>
    </slot>
    <div class="row q-gutter-x-sm q-mt-md">
      <div class="col bg-white shadow q-py-sm rounded-borders q-gutter-y-xs">
        <p class="text-center text-grey-8 text-weight-medium">
          Income Tax Savings
        </p>
        <div class="row justify-center" v-if="loading">
          <QSpinnerDots color="primary" size="18px" />
        </div>
        <p
          v-else
          class="text-title text-center text-primary text-weight-medium"
        >
          {{ taxSaving | frequency('monthly', frequency) | currency }}
        </p>
        <p class="text-body text-center text-grey-6">
          {{ taxSaving | frequency('monthly', 'yearly') | currency }}
          / year
        </p>
      </div>
      <div class="col bg-white shadow q-py-sm rounded-borders q-gutter-y-xs">
        <p class="text-center text-grey-8 text-weight-medium">GST Savings</p>
        <div class="row justify-center" v-if="loading">
          <QSpinnerDots color="primary" size="18px" />
        </div>
        <p
          v-else
          class="text-title text-center text-primary text-weight-medium"
        >
          {{ gstSavingBudget | frequency('monthly', frequency) | currency }}
        </p>
        <p class="text-body text-center text-grey-6">
          {{ gstSavingBudget | frequency('monthly', 'yearly') | currency }}
          / year
        </p>
      </div>
    </div>
    <div class="bg-white shadow q-py-sm rounded-borders q-gutter-y-xs q-mt-sm">
      <p class="text-center text-grey-8 text-weight-medium">
        GST savings on the car purchase price
      </p>
      <div class="row justify-center" v-if="loading">
        <QSpinnerDots color="primary" size="24px" />
      </div>
      <p v-else class="text-title text-center text-primary text-weight-medium">
        {{ gstSavingVehicle | currency }}
      </p>
    </div>
  </div>
</template>

<script>
import { QSpinnerDots } from 'quasar';

export default {
  name: 'LeaseTotalSavings',
  props: {
    loading: Boolean,
    taxSaving: Number,
    gstSavingBudget: Number,
    gstSavingVehicle: Number,
    frequency: {
      type: String,
      default: 'yearly'
    }
  },
  components: {
    QSpinnerDots
  }
};
</script>

<style lang="sass" scoped>
.shadow
  box-shadow: 0 2pt 6pt 0 rgba(0, 0, 0, 0.05)
</style>
